import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react';
import { LayoutPqrWeb } from '../../../layout/pqr_web';
import { PqrWebChannelDisabledScreen } from './channelDisabledScreen';

export const PqrWeb = () => {
    return (
        <>
            <LayoutPqrWeb title="Búsqueda de casos PQR" />
            {process.env.REACT_APP_PQR_WEB_RADICATION_ENABLED !== 'true' && (
                <PqrWebChannelDisabledScreen />
            )}
            <Grid
                container
                item
                xs={12}
                mt={8}
                direction="column"
                alignItems="center"
                justifyContent="center"
                style={{ minHeight: '50vh' }}
            >
                <Box
                    style={{
                        maxWidth: '400px',
                        textAlign: 'center',
                        padding: '16px',
                    }}
                >
                    <Typography
                        variant="h4"
                        style={{ fontWeight: 'bold', marginBottom: '16px' }}
                    >
                        Te damos la Bienvenida
                    </Typography>
                    <Typography variant="h6" style={{ marginBottom: '16px' }}>
                        Aquí podrás registrar, gestionar y/o consultar tus
                        peticiones, quejas o reclamos.
                    </Typography>
                    <Button
                        variant="outlined"
                        href="https://www.previsora.gov.co/"
                        target="_blanck"
                        sx={{ mt: 2 }}
                    >
                        Ir a Previsora.gov.co
                    </Button>
                </Box>
            </Grid>
        </>
    );
};
